import { css } from '@repo/pandacss/styled-system/css';
import type { PropsWithChildren } from 'react';

export function ChartWrapper({ children }: PropsWithChildren) {
  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: { base: 'center', md: 'space-between' },
        columnGap: '8',
        rowGap: '8',
        width: 'full',
      })}
    >
      {children}
    </div>
  );
}
